<template>
  <SetCompanyModal v-if="showSetCompanyModal" @closeModal="closeModal" />
  <div class="navbar navbar-dark bg-primary navbar-expand-lg navbar-static">
    <div class="container-fluid">
      <div class="navbar-brand me-3">
        <router-link to="/home" class="d-inline-flex align-items-center">
          <img
            src="@/assets/img/square_logo_color.png"
            class="h-32px"
            alt="Logo do Senar"
          />
          <span class="ms-2 text-white fs-lg">
            Sistema de Gestão de Contratos
          </span>
        </router-link>
      </div>
      <div class="d-xl-none">
        <button
          type="button"
          class="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-navigation"
          aria-expanded="true"
        >
          <i class="ph-list" />
        </button>
      </div>
      <div class="navbar-collapse collapse" id="navbar-navigation">
        <div class="navbar-nav ms-auto">
          <div class="alert bg-success mb-0 py-1 text-light">
            <span>
              <strong>{{ user.company }}</strong>
            </span>
          </div>
        </div>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Menu
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <a
                href="#"
                class="dropdown-item"
                title="Alterar Empresa"
                @click="showSetCompanyModal = true"
              >
                <i class="ph-user-switch me-2" />Alterar Empresa
              </a>
              <div class="dropdown-divider"></div>
              <router-link
                class="dropdown-item"
                to="/reports/my-measures"
                title="Minhas Medições"
              >
                <i class="ph-file me-2" />Minhas Medições
              </router-link>
              <router-link
                v-if="isFinancialManager"
                to="/reports/measures-invoiced"
                class="dropdown-item"
                title="Medições Faturadas"
              >
                <i class="ph-check-circle me-2" />Medições Faturadas
              </router-link>
              <div class="dropdown-divider"></div>
              <router-link
                v-if="isManager"
                to="/reports/manager-pendences"
                class="dropdown-item"
                title="Aprovações Pendentes (Gestor)"
              >
                <i class="ph-warning-circle me-2" />Aprovações Pendentes
                (Gestor)
              </router-link>
              <router-link
                v-if="isFinancialManager"
                to="/reports/financial-pendences"
                class="dropdown-item"
                title="Aprovações Pendentes (Ger. Financeira)"
              >
                <i class="ph-warning-circle me-2" />Aprovações Pendentes (Ger.
                Financeira)
              </router-link>
              <div class="dropdown-divider"></div>
              <router-link
                v-if="isManager"
                to="/admin/users"
                class="dropdown-item"
                title="Gerenciar Permissão de Usuários"
              >
                <i class="ph-users me-2" />Gerenciar Permissão de Usuários
              </router-link>
              <router-link
                v-if="user.name === 'totvs'"
                to="/admin/queries"
                class="dropdown-item"
                title="Gerenciar Permissão de Usuários"
              >
                <i class="ph-database me-2" />Gerenciar Consultas SQL
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ user.name }}
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <button
                type="button"
                class="dropdown-item"
                title="Permissão"
                disabled
                v-if="isAssistant"
              >
                Assistente
              </button>
              <button
                type="button"
                class="dropdown-item"
                title="Permissão"
                disabled
                v-if="isManager"
              >
                Gestor
              </button>
              <button
                type="button"
                class="dropdown-item"
                title="Permissão"
                disabled
                v-if="isFinancialManager"
              >
                Ger. Financeira
              </button>
              <button
                type="button"
                class="dropdown-item"
                title="Permissão"
                disabled
                v-if="isReportGeneral"
              >
                Relatórios
              </button>
              <button @click="logout" class="dropdown-item" title="Sair">
                <i class="ph-sign-out me-2" />Sair
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SetCompanyModal from '@/components/auth/SetCompanyModal.vue'
import PATHS from '@/router/routesMap'
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',

  components: {
    SetCompanyModal,
  },

  data() {
    return {
      showSetCompanyModal: false,
    }
  },

  computed: {
    ...mapGetters([
      'user',
      'isManager',
      'isAssistant',
      'isReportGeneral',
      'isFinancialManager',
    ]),
  },

  methods: {
    closeModal(redirectHome) {
      this.showSetCompanyModal = false
      if (redirectHome) {
        this.$router.push(PATHS.HOME)
        setTimeout(() => {
          this.$router.go(0)
        }, 150)
      }
    },

    logout() {
      this.$store.dispatch('logout').then(() => {
        localStorage.clear()
        this.$router.push(PATHS.BASE_URL)
      })
    },
  },
}
</script>
